import * as FIELD_NAME from 'constant/form-item-names'
import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editInsight } from 'action/insight'
import { getArticleDescription, resetState } from 'action/article'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import InsightForm from 'view/page/insight-management/component/insight-form'
import FormModal from 'view/component/form-modal'
import * as NUMBER from 'constant/number'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.title} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Insight edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const getInsightForm = (form, insight) => (
  <InsightForm
    form={form}
    insight={insight}
  />
)
const EditInsight = ({ insight, editInsight, getArticleDescription, submitting, resetState }) => {
  useEffect(() => {
    insight.category_uuid = _.compact(insight.category_uuid)
  }, [insight])
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const handleClick = () => {
    setVisible(true)
    getArticleDescription(insight.uuid)
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editInsight({ ...values, description_meta: form.getFieldValue(FIELD_NAME.DESCRIPTION_META), uuid: insight.uuid })
      setVisible(false)
      resetState()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>Edit Insight</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          resetState()
          form.setFieldsValue(insight)
        }}
        title='Edit Insight'
        visible={visible}
        width={NUMBER.EIGHTEEN_HUNDRED}
      >
        {getInsightForm(form, insight)}
      </FormModal>
    </>
  )
}

EditInsight.propTypes = {
  editInsight: PropTypes.func,
  getArticleDescription: PropTypes.func,
  insight: PropTypes.object,
  resetState: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.insightSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editInsight: bindActionCreators(editInsight, dispatch),
  getArticleDescription: bindActionCreators(getArticleDescription, dispatch),
  resetState: bindActionCreators(resetState, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditInsight)
